export const JIRA_EDITION_AWARENESS_FOR_PREMIUM_PILL_DISMISSED =
	'jira.user.theme.premium-ea-pill.dismissed' as const;
